import React from 'react';

import { Row, Col } from 'react-bootstrap5';

import Activities from './Activities';
import Feedbacks from './Feedbacks';

export default function Index() {
  return (
    <div className="mt-4">
      <Row>
        <Col lg={6} className="mb-5">
          <Activities />
        </Col>

        <Col lg={6} className="mb-5">
          <Feedbacks />
        </Col>
      </Row>
    </div>
  );
}
